import axios from 'axios';
import config from '../../config';
import { apiCode, apiConfig } from '../../services';
import { filePromises, load } from '../admin';
import { loadUserStats } from '../user';
import { clearImage, setShowSuccess } from '../ui';
import { SystemText } from '@salesperformanceint/e4shared';

export const ACTIVE_PROFILES_LOADED = 'ACTIVE_PROFILES_LOADED';
export const APPRAISAL_LOADED = 'APPRAISAL_LOADED';
export const AVAILABLE_COMPETENCIES_LOADED = 'AVAILABLE_COMPETENCIES_LOADED';
export const CLEAR_PROFILE = 'CLEAR_PROFILE';
export const COMPETENCIES_LOADED = 'COMPETENCIES_LOADED';
export const DISCUSSION_POINTS_LOADED = 'DISCUSSION_POINTS_LOADED';
export const ERROR = 'ERROR';
export const FORBIDDEN = 'FORBIDDEN';
export const LOADING = 'LOADING';
export const ONE_2_ONE_NOTES_LOADED = 'ONE_2_ONE_NOTES_LOADED';
export const PROFILE_LOADED = 'PROFILE_LOADED';
export const SAVING = 'SAVING';
export const TASK_LOADED = 'TASK_LOADED';
export const TASK_PROGRESS_LOADED = 'TASK_PROGRESS_LOADED';
export const TASK_SUMMARY_LOADED = 'TASK_SUMMARY_LOADED';
export const TASKS_LOADED = 'TASKS_LOADED';
export const TEAM_LOADED = 'TEAM_LOADED';
export const TEAMMATES_LOADED = 'TEAMMATES_LOADED';

export const profileLoaded = payload => {
    return {
        type: PROFILE_LOADED,
        payload,
    };
};

export const competenciesLoaded = payload => {
    return {
        type: COMPETENCIES_LOADED,
        payload,
    };
};

export const availableCompetenciesLoaded = payload => {
    return {
        type: AVAILABLE_COMPETENCIES_LOADED,
        payload,
    };
};

export const activeProfilesLoaded = payload => {
    return {
        type: ACTIVE_PROFILES_LOADED,
        payload,
    };
};

export const teamLoaded = payload => {
    return {
        type: TEAM_LOADED,
        payload,
    };
};

export const taskLoaded = payload => {
    return {
        type: TASK_LOADED,
        payload,
    };
};

export const taskProgressLoaded = payload => {
    return {
        type: TASK_PROGRESS_LOADED,
        payload,
    };
};

export const tasksLoaded = payload => {
    return {
        type: TASKS_LOADED,
        payload,
    };
};

export const discussionPointsLoaded = payload => {
    return {
        type: DISCUSSION_POINTS_LOADED,
        payload,
    };
};

export const one2OneNotesLoaded = payload => {
    return {
        type: ONE_2_ONE_NOTES_LOADED,
        payload,
    };
};

export const teamMatesLoaded = payload => {
    return {
        type: TEAMMATES_LOADED,
        payload,
    };
};

export const taskSummaryLoaded = payload => {
    return {
        type: TASK_SUMMARY_LOADED,
        payload,
    };
};

export const appraisalLoaded = payload => {
    return {
        type: APPRAISAL_LOADED,
        payload,
    };
};

export const loading = payload => {
    return {
        type: LOADING,
        payload,
    };
};

export const saving = payload => {
    return {
        type: SAVING,
        payload,
    };
};

export const error = payload => {
    return {
        type: ERROR,
        payload,
    };
};

export const forbidden = () => {
    return {
        type: FORBIDDEN,
    };
};

export const clearError = () => {
    return {
        type: ERROR,
        payload: false,
    };
};

export const clearProfile = () => {
    return {
        type: CLEAR_PROFILE,
    };
};

export const loadProfile = id => {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(false));

        const { guid } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}profile/${id}${apiCode()}`, apiConfig(guid))
            .then(response => {
                dispatch(profileLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            })
            .finally(() => dispatch(loading(false)));
    };
};

export const loadProfileFromHandle = handle => {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(false));

        const { guid } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}profile-from-handle/${handle}${apiCode()}`, apiConfig(guid))
            .then(response => {
                dispatch(profileLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            })
            .finally(() => dispatch(loading(false)));
    };
};

export const loadCompetencies = (id, benchmark) => {
    benchmark = benchmark || 0;
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}profile/${id}/competencies/${benchmark}${apiCode()}`, apiConfig(guid))
            .then(response => {
                dispatch(competenciesLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
                dispatch(competenciesLoaded(null));
            })
            .finally(() => dispatch(loading(false)));
    };
};

export const loadOne2OneNotes = id => {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}profile/${id}/121notes${apiCode()}`, apiConfig(guid))
            .then(response => {
                dispatch(one2OneNotesLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            })
            .finally(() => dispatch(loading(false)));
    };
};

export const loadActiveProfiles = () => {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}active-profiles${apiCode()}`, apiConfig(guid))
            .then(response => {
                dispatch(activeProfilesLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            })
            .finally(() => dispatch(loading(false)));
    };
};

export const sendInvite = (id, notifications) => {
    return (dispatch, getState) => {
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .post(`${config.apiGateway.URL}send-invite${apiCode(true)}`, { id, notifications }, apiConfig(guid))
            .then(response => {
                dispatch(setShowSuccess(SystemText('Admin/User/Invite/Success')));
                dispatch(load('profile'));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            });
    };
};

export const competenciesByProfiles = ids => {
    ids = ids.filter(x => x);
    return (dispatch, getState) => {
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .post(`${config.apiGateway.URL}competencies-by-profiles${apiCode(true)}`, ids, apiConfig(guid))
            .then(response => {
                dispatch(availableCompetenciesLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
            });
    };
};

export const loadTasks = (id, page, filter, competencyId, callback) => {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(false));
        const { guid } = getState().user.user;
        const queryString = `competencyId=${competencyId}&page=${page}&filter=${filter}`;
        return axios
            .get(`${config.apiGateway.URL}profile/${id}/tasks${apiCode(true)}${queryString}`, apiConfig(guid))
            .then(response => {
                dispatch(tasksLoaded(response.data));
                callback?.();
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            })
            .finally(() => dispatch(loading(false)));
    };
};

export const loadTasksByMonth = (id, filter, search, month, year) => {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(false));
        const { guid } = getState().user.user;
        const queryString = `year=${year}&month=${month}&filter=${filter}&search=${search}`;
        return axios
            .get(`${config.apiGateway.URL}profile/${id}/tasks${apiCode(true)}${queryString}`, apiConfig(guid))
            .then(response => {
                dispatch(tasksLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            })
            .finally(() => dispatch(loading(false)));
    };
};

export const deleteTask = (id, callback) => {
    return (dispatch, getState) => {
        const { guid } = getState().user.user;
        return axios
            .delete(`${config.apiGateway.URL}task/${id}${apiCode()}`, apiConfig(guid))
            .then(response => {
                callback?.();
                dispatch(loadUserStats());
            })
            .catch(err => {
                // console.log(err);
            });
    };
};

export const unassignTask = (id, callback) => {
    return (dispatch, getState) => {
        const { guid } = getState().user.user;
        return axios
            .patch(`${config.apiGateway.URL}unassign-task/${id}${apiCode()}`, null, apiConfig(guid))
            .then(response => {
                callback?.();
            })
            .catch(err => {
                // console.log(err);
            });
    };
};

export const loadTaskProgress = id => {
    return (dispatch, getState) => {
        const { guid } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}task-progress/${id}${apiCode()}`, apiConfig(guid))
            .then(response => {
                dispatch(taskProgressLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
            });
    };
};

export const poke = (task, callback) => {
    return (dispatch, getState) => {
        dispatch(error(false));
        dispatch(setShowSuccess(false));
        const { user } = getState().user;
        return axios
            .patch(`${config.apiGateway.URL}poke${apiCode()}`, task, apiConfig(user.guid))
            .then(response => {
                dispatch(setShowSuccess(SystemText('Objective/Poke/Success', task.assigned_Firstname)));
                callback?.();
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            });
    };
};

export const updateRating = (rating, benchmark, callback) => {
    return (dispatch, getState) => {
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .patch(`${config.apiGateway.URL}rating${apiCode()}`, rating, apiConfig(guid))
            .then(response => {
                dispatch(loadCompetencies(rating.profile_Id, benchmark));
                callback?.();
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            });
    };
};

export const updateFlag = (item, benchmark) => {
    return (dispatch, getState) => {
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .patch(`${config.apiGateway.URL}flag${apiCode()}`, item, apiConfig(guid))
            .then(response => {
                dispatch(loadCompetencies(item.profile_Id, benchmark));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            });
    };
};

export const saveNotes = (notes, callback) => {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(setShowSuccess(false));
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .patch(`${config.apiGateway.URL}profile-121note${apiCode()}`, notes, apiConfig(guid))
            .then(response => {
                callback?.();
                dispatch(setShowSuccess(SystemText('User121/Notes/Manage/Success')));
                dispatch(loadOne2OneNotes(notes.profile_Id));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            })
            .finally(() => dispatch(loading(false)));
    };
};

export const deleteNote = note => {
    return (dispatch, getState) => {
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .delete(`${config.apiGateway.URL}profile/note/${note.id}${apiCode()}`, apiConfig(guid))
            .then(response => {
                dispatch(loadOne2OneNotes(note.profile_Id));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            });
    };
};

export const loadAppraisals = id => {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}appraisals/${id}/${apiCode()}`, apiConfig(guid))
            .then(response => {
                dispatch(appraisalLoaded(response.data));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            })
            .finally(() => dispatch(loading(false)));
    };
};

export const saveAppraisal = (appraisal, callback) => {
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(setShowSuccess(false));
        dispatch(error(false));
        const { guid } = getState().user.user;
        return axios
            .patch(`${config.apiGateway.URL}appraisal${apiCode()}`, appraisal, apiConfig(guid))
            .then(response => {
                callback?.();
                dispatch(loadAppraisals(appraisal.profile_Id));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            })
            .finally(() => dispatch(loading(false)));
    };
};
